import * as style from "@COMPONENTS/style/detailpackage/option";
import {TextButton} from "@FRAMEWORK/ui/desktop/button";
import {BlueText} from "@FRAMEWORK/ui/desktop/text";
import {useRef, useState} from "react";
import {EditorBox} from "@FRAMEWORK/ui/desktop/editor";
import useEventOptionalTourDetail from "@QUERIES/prdt/event/useEventOptionalTourDetail";
import ErrorBoundary from "@COMPONENTS/common/error/ErrorBoundary";
import useEventTourDetail from "@QUERIES/bff/useEventTourDetail";
import {Noimage} from "@yb/ui/desktop/common/Noimage";

const OptionComponent = ({evCd}: {evCd: string}) => {
	const useEventOptTourDtl = useEventOptionalTourDetail(evCd);
	const useEventTourDtl = useEventTourDetail(evCd);

	const evtOptTourDtl = useEventOptTourDtl.data?.body;
	const option = evtOptTourDtl?.optionList || [];
	const optionalTour = useEventTourDtl.data.optionalTour;

	const ListOptionRef = useRef([]);
	const ListTourRef = useRef([]);

	// toggle list
	const [optionExpand, setOptionExpand] = useState<number[]>([]);
	const [travelExpand, setTravelExpand] = useState<number[]>([]);

	const handleToggleOption = (index: number) => {
		const newState = [...optionExpand];
		if (newState.includes(index)) {
			setOptionExpand(newState.filter(i => i !== index));
		} else {
			newState.push(index);
			setOptionExpand(newState);
		}
	};

	const handleToggleTravel = (index: number) => {
		const newState = [...travelExpand];
		if (newState.includes(index)) {
			setTravelExpand(newState.filter(i => i !== index));
		} else {
			newState.push(index);
			setTravelExpand(newState);
		}
	};

	// 옵션 전체 버튼
	const handleToggleAllOption = () => {
		optionExpand.length === option.length && setOptionExpand([]);
		optionExpand.length !== option.length && setOptionExpand(option.map((o, i) => i));
	};

	// 선택관광 전체 버튼
	const handleToggleAllTravel = () => {
		travelExpand.length === optionalTour.data.length && setTravelExpand([]);
		travelExpand.length !== optionalTour.data.length && setTravelExpand(optionalTour.data.map((o, i) => i));
	};

	return (
		<>
			{option.length === 0 && !optionalTour.show && (
				<>
					<style.ContentTitleWrap>
						<style.ContentTitle>옵션</style.ContentTitle>
					</style.ContentTitleWrap>
					<style.List>
						<li>
							<style.TextNone>해당 상품은 옵션이 포함되지 않습니다.</style.TextNone>
						</li>
					</style.List>
				</>
			)}
			{option.length > 0 && (
				<>
					<style.ContentTitleWrap>
						<style.ContentTitle>옵션</style.ContentTitle>
						<style.ButtonWrap>
							<TextButton
								onClick={handleToggleAllOption}
								text={optionExpand.length === option.length ? "전체닫기" : "전체열기"}
								size="default"
							/>
						</style.ButtonWrap>
					</style.ContentTitleWrap>
					<style.List>
						{option.map((item, index) => {
							const {imageUrl, intro, title, cost, useTm, note} = item;
							const {accompanyYn, waitingArea, waitingSche} = item;
							return (
								<style.ListItem key={index}>
									<style.ListContent onClick={() => handleToggleOption(index)} isActive={optionExpand.includes(index)}>
										<style.ListTitle>
											<h5>{title}</h5>
										</style.ListTitle>
										<style.PriceWrap>
											{cost && (
												<style.Price>
													<span>비용</span>
													{cost}
												</style.Price>
											)}
											<style.MoreButton isActive={optionExpand.includes(index)}>
												<span>더보기</span>
											</style.MoreButton>
										</style.PriceWrap>
									</style.ListContent>
									<style.ListDetail
										contentHeight={ListOptionRef.current[index]?.clientHeight}
										isActive={optionExpand.includes(index)}
									>
										<div ref={el => (ListOptionRef.current[index] = el)}>
											{imageUrl && (
												<style.Thumbnail>
													<Noimage width="190px" height="auto" src={imageUrl} alt="" />
												</style.Thumbnail>
											)}
											<style.TextBox>
												<p>{intro}</p>
												<style.Summary>
													{cost && (
														<dl>
															<dt>비용</dt>
															<dd>
																<BlueText>{cost}</BlueText>
															</dd>
														</dl>
													)}
													{useTm && (
														<dl>
															<dt>소요시간</dt>
															<dd>
																<BlueText>{useTm}</BlueText>
															</dd>
														</dl>
													)}
												</style.Summary>
												{accompanyYn && waitingArea && waitingSche && (
													<style.Note>
														<span>미참가시</span>
														<EditorBox>
															<table>
																<caption>미참가시</caption>
																<colgroup>
																	<col style={{width: "33.333%"}} />
																	<col style={{width: "33.333%"}} />
																	<col style={{width: "33.333%"}} />
																</colgroup>
																<thead>
																	<tr>
																		<th scope="col">대기일정</th>
																		<th scope="col">대기장소</th>
																		<th scope="col">가이드동행여부</th>
																	</tr>
																</thead>
																<tbody>
																	<tr>
																		<td style={{textAlign: "center"}}>{waitingSche}</td>
																		<td style={{textAlign: "center"}}>{waitingArea}</td>
																		<td style={{textAlign: "center"}}>{accompanyYn}</td>
																	</tr>
																</tbody>
															</table>
														</EditorBox>
													</style.Note>
												)}
												{note && (
													<style.Note>
														<dt>참고사항</dt>
														<dd>
															<EditorBox dangerouslySetInnerHTML={{__html: note.replace(/\r\n/g, "<br/>")}} />
														</dd>
													</style.Note>
												)}
											</style.TextBox>
										</div>
									</style.ListDetail>
								</style.ListItem>
							);
						})}
					</style.List>
					<style.AditorCaution>
						<EditorBox dangerouslySetInnerHTML={{__html: evtOptTourDtl?.optionalTourInfo.optInfo}} />
					</style.AditorCaution>
				</>
			)}

			{optionalTour.show && (
				<>
					<style.ContentTitleWrap>
						<style.ContentTitle>선택관광</style.ContentTitle>
						<style.ButtonWrap>
							<TextButton
								onClick={handleToggleAllTravel}
								text={travelExpand.length === optionalTour.data.length ? "전체닫기" : "전체열기"}
								size="default"
							/>
						</style.ButtonWrap>
					</style.ContentTitleWrap>
					<style.List>
						{optionalTour.data.map((item, index) => {
							const {trvInfoNm, optCost, trvContent, image1Url, useTm} = item;
							return (
								<style.ListItem key={index}>
									<style.ListContent onClick={() => handleToggleTravel(index)} isActive={optionExpand.includes(index)}>
										<style.ListTitle>
											<h5>{trvInfoNm}</h5>
										</style.ListTitle>
										<style.PriceWrap>
											<style.Price>
												<span>비용</span>
												{optCost}
											</style.Price>
											<style.MoreButton isActive={travelExpand.includes(index)}>
												<span>더보기</span>
											</style.MoreButton>
										</style.PriceWrap>
									</style.ListContent>
									<style.ListDetail
										contentHeight={ListTourRef.current[index]?.clientHeight}
										isActive={travelExpand.includes(index)}
									>
										<div ref={el => (ListTourRef.current[index] = el)}>
											{image1Url && (
												<style.Thumbnail>
													<Noimage width="190px" height="130px" src={image1Url} alt="" />
												</style.Thumbnail>
											)}
											<style.TextBox>
												<style.Summary>
													{optCost && (
														<dl>
															<dt>비용</dt>
															<dd>
																<BlueText>{optCost}</BlueText>
															</dd>
														</dl>
													)}
													{useTm && (
														<dl>
															<dt>소요시간</dt>
															<dd>
																<BlueText>{useTm}</BlueText>
															</dd>
														</dl>
													)}
												</style.Summary>
												{trvContent && (
													<style.Note>
														<dt>참고사항</dt>
														<dd>
															<EditorBox dangerouslySetInnerHTML={{__html: trvContent.replace(/\r\n/g, "<br/>")}} />
														</dd>
													</style.Note>
												)}
											</style.TextBox>
										</div>
									</style.ListDetail>
								</style.ListItem>
							);
						})}
					</style.List>
				</>
			)}
		</>
	);
};

const Option = (props: {evCd: string}) => (
	<ErrorBoundary logMsg="Option Error">
		<OptionComponent {...props} />
	</ErrorBoundary>
);

export default Option;
